var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yd-table",
        {
          attrs: {
            loading: _vm.loading,
            data: _vm.tableData,
            pagination: _vm.pageState,
            settings: { showIndex: true },
          },
          on: { onChange: _vm.onTableChange },
          scopedSlots: _vm._u([
            {
              key: "statistics",
              fn: function () {
                return [
                  _c("span", [
                    _vm._v(
                      "合计金额 " +
                        _vm._s(_vm.allMoney) +
                        " 元，当前页合计 " +
                        _vm._s(_vm.curPageMoney) +
                        " 元"
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        _vm._l(_vm.tableColumns, function (item, index) {
          return _c("el-table-column", {
            key: index,
            attrs: {
              align: "center",
              prop: item.filed,
              label: item.title,
              width: item.width,
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      item.filed === "linkRecordId"
                        ? [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.deleteLoading,
                                  type: "text",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewContent(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            查看详情\n          ")]
                            ),
                            scope.row.channel === 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      loading: _vm.deleteLoading,
                                      type: "text",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("\n            删除\n          ")]
                                )
                              : _vm._e(),
                          ]
                        : _c("span", [
                            _vm._v(_vm._s(scope.row["" + item.filed])),
                          ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }